import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddReaction = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M20.93 13.1a9 9 0 1 1 -10.03 -10.05" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 14.5s1.5 2 4 2 4-2 4-2" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 9,
			y1: 9.5,
			x2: 9.01,
			y2: 9.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 15,
			y1: 9.5,
			x2: 15.01,
			y2: 9.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			y1: 2,
			x2: 19,
			y2: 8
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y1: 5,
			x2: 22,
			y2: 5
		})
	]
});
export default SvgAddReaction;
